import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { useI18n } from '../../i18n/useI18n';

interface SuspensionGuardProps {
  children: ReactNode;
}

/**
 * Guard: Verifica si la cuenta del fotógrafo está suspendida
 * Si está suspendida, redirige a /account/suspended
 */
export function SuspensionGuard({ children }: SuspensionGuardProps) {
  const { profile, loading } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && profile) {
      // Si el perfil está suspendido, redirigir a página de suspensión
      if (profile.status === 'suspended') {
        navigate('/account/suspended', { replace: true });
      }
    }
  }, [profile, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-gray-900 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  // Si está suspendido, no renderizar nada (ya redirigió)
  if (profile?.status === 'suspended') {
    return null;
  }

  return <>{children}</>;
}
